import { render } from "./TarjetaHomeMejoresOfertas.vue?vue&type=template&id=23171195&scoped=true"
import script from "./TarjetaHomeMejoresOfertas.vue?vue&type=script&lang=js"
export * from "./TarjetaHomeMejoresOfertas.vue?vue&type=script&lang=js"

import "./TarjetaHomeMejoresOfertas.vue?vue&type=style&index=0&id=23171195&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23171195"]])

export default __exports__